// extracted by mini-css-extract-plugin
export default {"root":"_2PBmr","variant-horizontal":"_1IV0Y","variantHorizontal":"_1IV0Y","title":"_2iWsf","message":"_33sxL","core-star":"_1N5pC","coreStar":"_1N5pC"};